import React from 'react';
import { cn } from '@/lib/utils';

const baseFieldStyles = 'w-full px-3 py-2 rounded-md text-sm transition-all border bg-transparent ' +
  'border-[var(--border)] text-[var(--text-primary)] placeholder:text-[var(--text-muted)] ' +
  'focus:outline-none focus:ring-1 focus:ring-[var(--brand-cyan)]/50 focus:border-[var(--brand-cyan)]/50 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const Input = ({ label, error, className, ...props }) => (
  <div className="w-full">
    {label && (
      <label className="block text-xs font-medium text-[var(--text-secondary)] mb-1.5 tracking-tight">
        {label}
      </label>
    )}
    <input
      className={cn(baseFieldStyles, error && 'border-[var(--status-danger)] focus:ring-[var(--status-danger)]/50', className)}
      {...props}
    />
    {error && (
      <p className="mt-1 text-xs text-[var(--status-danger)]">{error}</p>
    )}
  </div>
);

export const Select = ({ label, error, children, className, ...props }) => (
  <div className="w-full">
    {label && (
      <label className="block text-xs font-medium text-[var(--text-secondary)] mb-1.5 tracking-tight">
        {label}
      </label>
    )}
    <select
      className={cn(baseFieldStyles, 'cursor-pointer appearance-none bg-[var(--surface)] pr-8', error && 'border-[var(--status-danger)]', className)}
      style={{
        backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23888'%3e%3cpath fill-rule='evenodd' d='M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z' clip-rule='evenodd'/%3e%3c/svg%3e\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 8px center',
        backgroundSize: '16px'
      }}
      {...props}
    >
      {children}
    </select>
    {error && (
      <p className="mt-1 text-xs text-[var(--status-danger)]">{error}</p>
    )}
  </div>
);

export const Textarea = ({ label, error, className, ...props }) => (
  <div className="w-full">
    {label && (
      <label className="block text-xs font-medium text-[var(--text-secondary)] mb-1.5 tracking-tight">
        {label}
      </label>
    )}
    <textarea
      className={cn(baseFieldStyles, 'resize-y min-h-[60px] leading-relaxed', error && 'border-[var(--status-danger)]', className)}
      {...props}
    />
    {error && (
      <p className="mt-1 text-xs text-[var(--status-danger)]">{error}</p>
    )}
  </div>
);
